import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { LogoBlack } from '../../common/icons/Logos';

import ResetPasswordForm from '../../auth/reset-password/ResetPasswordForm.jsx';

const ResetPasswordPageMobile = props => {
  const { token } = props.match.params;
  return (
    <div className="m-container">
      <div className="is-flex justify-content-center py-20px">
        <Link to="/">
          <LogoBlack />
        </Link>
      </div>

      <p className="auth-page-title">Create new password</p>
      <ResetPasswordForm token={token} />
    </div>
  );
};

ResetPasswordPageMobile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ResetPasswordPageMobile;
